import "./logrocket-init";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import TagManager from "react-gtm-module";
import * as Sentry from "@sentry/react";
import { auth } from "Components";

TagManager.initialize({
  gtmId: process.env.REACT_APP_GTM_ID || "GTM-KSTZVPM8",
});

if (process.env.NODE_ENV === "production" && process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV || "development",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        networkDetailAllowUrls: [/(dev-)?set.(live|rocks)/i],
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // TODO: THis should also send traces to the search.set.live domains but currently
    // those won't work because of CORS issues
    tracePropagationTargets: ["localhost", /^https:\/\/artists\./],
    // Session Replay
    replaysSessionSampleRate: 0,
    // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    replaysOnErrorSampleRate: 1.0,
    release: process.env.REACT_APP_SHA || "unknown",
  });
}

auth.onAuthStateChanged((user) => {
  if (user) {
    Sentry.setUser({
      id: user.uid,
      email: user.email ?? "",
    });
  } else {
    Sentry.setUser(null);
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
